import React, { Component } from 'react';
import { connect } from 'react-redux';

import QuestionnaireName from './DocumentProperties/QuesitonnaireName';
// import PatientType from './DocumentProperties/PatientType';
import AppointmentType from './DocumentProperties/AppointmentType';
import DocumentSignature from './DocumentProperties/DocumentSignature';

import DateProperties from './Type/DateProperties';
import DisplayProperties from './Type/DisplayProperties';
import LongTextProperties from './Type/LongTextProperties';
import MedicationSearchProperties from './Type/MedicationSearchProperties';
import PainScaleProperties from './Type/PainScaleProperties';
import AttachmentProperties from './Type/AttachmentProperties';
import ShortTextProperties from './Type/ShortTextProperties';
import YesNoProperties from './Type/YesNoProperties';
import ChoiceProperties from './Type/ChoiceProperties';
import OpenChoiceProperties from './Type/OpenChoiceProperties';
import IntegerProperties from './Type/IntegerProperties';

function questionProperties(question, position) {
  switch (question.type) {
    case 'date':
      return <DateProperties question={question} position={position} />;
    case 'display':
      return <DisplayProperties question={question} position={position} />;
    case 'text':
      return <LongTextProperties question={question} position={position} />;
    case 'medication-search':
      return <MedicationSearchProperties question={question} position={position} />;
    case 'pain-scale':
      return <PainScaleProperties question={question} position={position} />;
    case 'attachment':
      return <AttachmentProperties question={question} position={position} />;
    case 'string':
      return <ShortTextProperties question={question} position={position} />;
    case 'boolean':
      return <YesNoProperties question={question} position={position} />;
    case 'choice':
      return <ChoiceProperties question={question} position={position} />;
    case 'open-choice':
      return <OpenChoiceProperties question={question} position={position} />;
    case 'integer':
      return <IntegerProperties question={question} position={position} />
    default:
      return false;
  }
}

const PropertyFactory = (question, position) => {
  if (question === false) {
    return <>
      <h5 className="mt-4 mb-4"><u>Form Properties</u></h5>

      <QuestionnaireName />

      {/* <PatientType /> */}

      <AppointmentType />

      <DocumentSignature />
    </>;
  }

  return <>
    <h5 className="mt-4 mb-4"><u>Question Properties</u></h5>

    {questionProperties(question, position)}
  </>
};

class Properties extends Component {
  render() {
    let { question, position } = this.props;

    return <div>
      <h5 style={{ borderBottom: '4px solid #1AB2E9', cursor: 'pointer' }}>Properties</h5>

      <div key={question.linkId}>
        {PropertyFactory(question, position)}
      </div>
    </div>
  }
}

const mapStateToProps = state => {
  let position = false;

  let question = state.questionnaire.current.item.find((item, index) => {
    if (item.linkId === state.questionnaire.editQuestion) {
      position = index;

      return true;
    }
  });

  return {
    question: question ? question : false,
    position: position
  }
}

export default connect(mapStateToProps)(Properties);